<template>
    <li class="font-14 has-text-greyText mb-2">
        <p class="break-name">{{ user.name }}</p>
    </li>
</template>

<script>
export default {
    name: "user",
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.break-name {
    overflow-wrap: anywhere;
}
</style>